var render, staticRenderFns
import script from "./BaseStep.vue?vue&type=script&lang=ts&"
export * from "./BaseStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-cfm/mfe-cfm/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59bc19be')) {
      api.createRecord('59bc19be', component.options)
    } else {
      api.reload('59bc19be', component.options)
    }
    
  }
}
component.options.__file = "src/components/wizard/BaseStep.vue"
export default component.exports